import React from 'react'
import { Breadcrumbs } from '@/components/ui/breadcrumb'
import { getTicketFields } from 'components/Filter/TicketFields'
import { links } from 'utils/featureToggles'

import Tickets from './Tickets/Tickets'
import { ticketsColumn } from './ticketsColumn'
import { TicketsViewType } from './TicketsViewType'

const TicketsBackOffice = (): JSX.Element => (
  <React.Fragment>
    <Breadcrumbs crumbs={[{ title: 'Backoffice Tickets', link: links.ticketsBackoffice.url }]} />
    <Tickets
      viewType={TicketsViewType.BackOffice}
      columns={ticketsColumn}
      filterFields={getTicketFields}
    />
  </React.Fragment>
)

export default TicketsBackOffice
